import api from '../../services/payment';
export default function (helper) {
	/**
	 * Generated store module
	 */
	helper.setApi(api);
	const types = helper.types('payment');
	const state = helper.state();
	const getters = helper.getters();
	const actions = helper.actions({
		/**
		 * Get Payment Plans
		 * @returns {Promise}
		 */
		getPlans() {
			helper.log().info(`[Store: Payment]: Get payment plans`);
			return new Promise((resolve, reject) => {
				return api
					.getPlans()
					.then((response) => {
						helper.log().info(`[Store: Payment]: Got payment plans`, response);
						const data = response.data.data;
						resolve(data);
					})
					.catch((error) => {
						helper.log().info(`[Store: Payment]: Error Getting payment plans`, error);
						reject(error);
					});
			});
		},
		/**
		 * Subscription Checkout
		 * @param {any} params
		 * @returns {Promise}
		 */
		checkout(context, params) {
			helper.log().info(`[Store: Payment]: Checkout`, params);
			return new Promise((resolve, reject) => {
				return api
					.checkout(params)
					.then((response) => {
						helper.log().info(`[Store: Payment]: Checkout`, response);
						resolve(response.data.data);
					})
					.catch((error) => {
						helper.log().info(`[Store: Payment]: Checkout Error`, error);
						reject(error);
					});
			});
		},
		/**
		 * Custom Quote for Enterprise Plan
		 * @returns {Promise}
		 */
		customQuote() {
			helper.log().info(`[Store: Payment]: Custom Quote`);
			return new Promise((resolve, reject) => {
				return api
					.customQuote()
					.then((response) => {
						helper.log().info(`[Store: Payment]: Custom Quote`, response);
						resolve(response.data.data);
					})
					.catch((error) => {
						helper.log().info(`[Store: Payment]: Custom Quote Error`, error);
						reject(error);
					});
			});
		},
		/** Get Subscribed Plan
		 * @returns {Promise}
		 */
		subscribedPlan(context, id) {
			helper.log().info(`[Store: Payment]: Get subscribed plan`, id);
			return new Promise((resolve, reject) => {
				return api
					.getSubscribedPlan(id)
					.then((response) => {
						helper.log().info(`[Store: Payment]: Got subscribed plan`, response);
						const data = response.data.data;
						resolve(data);
					})
					.catch((error) => {
						helper.log().info(`[Store: Payment]: Error Getting subscribed plan`, error);
						reject(error);
					});
			});
		},
		/**
		 * Update Subscription
		 * @returns {Promise}
		 */
		updateSubscription(context, params) {
			helper.log().info(`[Store: Payment]: Update subscription`, params);
			return new Promise((resolve, reject) => {
				return api
					.updateSubscription(params)
					.then((response) => {
						helper.log().info(`[Store: Payment]: Updated subscription`, response);
						const data = response.data.data;
						resolve(data);
					})
					.catch((error) => {
						helper.log().info(`[Store: Payment]: Error Updating subscription`, error);
						reject(error);
					});
			});
		},
		/**
		 * Get Stripe Customer Billing Portal Details
		 * @returns {Promise}
		 */
		customerPortal() {
			helper.log().info(`[Store: Payment]: Get Customer Portal`);
			return new Promise((resolve, reject) => {
				return api
					.getCustomerPortal()
					.then((response) => {
						helper.log().info(`[Store: Payment]: Got Customer Portal`, response);
						const data = response.data.data;
						resolve(data);
					})
					.catch((error) => {
						helper.log().info(`[Store: Payment]: Error Getting Customer Portal`, error);
						reject(error);
					});
			});
		},
	}, 'Payment');
	const mutations = helper.mutations({}, types, state);

	return {
		namespaced: true,
		state,
		getters,
		actions,
		mutations
	};
}